<template>
	<li class="c-mobile-menu__item">
		<button
			:id="'item-' + id"
			class="c-mobile-menu__item__button"
			:aria-controls="'content-' + id"
			:aria-expanded="expanded ? 'true' : 'false'"
			@click="expanded = !expanded"
		>
			<span>
				<v-icon :name="icon" size="s"></v-icon>
				<span class="c-mobile-menu__item__button-text">{{ name }}</span>
			</span>
			<v-icon
				name="icon-chevron"
				size="xs"
				:class="[
					{ 'c-mobile-menu__item__arrow--active': expanded },
					'c-mobile-menu__item__arrow'
				]"
			></v-icon>
		</button>
		<Transition name="fade">
			<ul
				class="c-mobile-menu__sublist"
				v-if="expanded"
				:id="'content-' + id"
			>
				<li
					:class="[
						'c-mobile-menu__subitem',
						{ 'c-mobile-menu__subitem--active': subitem.isActive }
					]"
					v-for="(subitem, subindex) in items"
					:key="subindex"
				>
					<a :href="subitem.url" class="c-mobile-menu__link"
						><span>{{ subitem.name }}</span></a
					>
				</li>
			</ul>
		</Transition>
	</li>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";

export default {
	name: "VMobileMenu",
	components: { VIcon },
	props: {
		id: { type: Number },
		name: { type: String },
		selected: { type: Boolean },
		icon: { type: String },
		items: { type: Array }
	},
	data() {
		return {
			expanded: this.selected
		};
	}
};
</script>
